import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../api/apiInterceptor";
import {
    createTrigger,
    deleteInstructionUrl,
    deleteTriggerUrl,
    fetchAllInstructionsPaggination,
    fetchAllTriggersPaggination,
    updateTriggerUrl
} from "../components/Triggers/TriggerApi";
import {displayNotification} from "./notification";

const initialState = {
    triggersItem: [],
    instructionsData: [],
    isLoading: false,
    devicesItemById: [],
    locationData: [],
    locationItemById: [],
    allLocationItem:[],
    editInstruction: {},
    editTrigger:{},
    modalVisible: false,
    modalVisibleInstruction: false,
    showMessage: false,
    textMessage: "",
    appLoader: false,
    idModal: undefined,
    isUpdateInstruction: false,
    modalVisibleTrigger:false,
    isUpdateTrigger:false,
    pagination: {
        currentPage: 0,
        total: 0,
        pageSize: 0,
    },
    deleteConfirmation: false,
    deleteConfirmationTriggers: false,
    paginationInstructions: {
        currentPageInst: 0,
        totalInst: 0,
        pageSizeInst: 0,
    }
}

export const fetchDevicesByInstallationsID = createAsyncThunk(
    "fetchTriggerByIdDevices",
    async ({installationId}) => {
        try {
            const resultDevices = await api.get(`api/installations/${installationId}/devices`);
            return resultDevices.data;
        } catch (err) {
            console.log(err)
        }
    }
)

export const fetchLocationsByInstallationsID = createAsyncThunk(
    "fetchLocationsByInstallationsID",
    async ({installationId}) => {
        try {
            const resultLocations = await api.get(`api/installations/${installationId}/locations`);
            return resultLocations.data;
        } catch (err) {
            console.log(err)
        }
    }
)

export const fetchAllLocations = createAsyncThunk(
    "all_loactions",
    async ({installationId}) => {
        try {
            const resultLocations = await api.get(`api/installations/${installationId}/locations/all`);
            return resultLocations.data;
        } catch (err) {
            console.log(err)
        }
    }
)

export const fetchTriggersByInstallationsId = createAsyncThunk(
    "fetchTriggersByLocationId",
    async ({installationId, page = 0, pageSize = 10}) => {
        try {
            const result = await fetchAllTriggersPaggination(installationId, page, pageSize);
            return result.data;
        } catch (err) {
            console.log(err)
        }
    }
)

export const createNewTrigger = createAsyncThunk(
    "create/trigger",
    async ({installationId, data, page = 0, pageSize = 10}, {dispatch}) => {
        const response = await createTrigger(installationId, data);
        dispatch(fetchTriggersByInstallationsId({installationId: installationId, page: page, pageSize: pageSize}))
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Kreirano",
            title: "Kreiranje okidača"
        }))
        return response.data;
    }
)

export const updateTrigger = createAsyncThunk(
    'trigger/put',
    async ({installationId, triggerItemId, page = 0, pageSize = 10, data}, {dispatch}) => {
        const response = await updateTriggerUrl(installationId, triggerItemId,data)
        dispatch(fetchTriggersByInstallationsId({installationId: installationId, page: page, pageSize: pageSize}))
        dispatch(hideModalTriggerUpdate())
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Okidač uspješno ažurirana.",
            title: "Ažuriranje okidača"
        }))
        return response.data;
    }
)

export const deleteTrigger = createAsyncThunk(
    '/trigger/delete',
    async ({installationId, triggerItemId, page = 0, pageSize = 10}, {dispatch}) => {
        const response = await deleteTriggerUrl(installationId, triggerItemId);
        dispatch(fetchTriggersByInstallationsId({installationId: installationId, page: page, pageSize: pageSize}))
        dispatch(displayNotification({notificationStatus: "error", message: "Obrisano", title: "Brisanje okidača"}))
        return response.data;
    }
)


export const fetchInstructions = createAsyncThunk(
    "getInstructions/trigger",
    async ({installationId, triggerItemId, page = 0, pageSize = 10}) => {
        try {
            const result = await fetchAllInstructionsPaggination(installationId, triggerItemId, page, pageSize);
            return result.data;
        } catch (err) {
            console.log(err)
        }
    }
)

export const createNewInstruction = createAsyncThunk(
    '/instrukcije/create',
    async ({installationId, triggerItemId, page = 0, pageSize = 10, data}, {dispatch}) => {
        const response = await api.post(`/api/installations/${installationId}/triggers/${triggerItemId}/instructions`, data);
        dispatch(fetchInstructions({
            installationId: installationId,
            triggerItemId: triggerItemId,
            page: page,
            pageSize: pageSize
        }))
        dispatch(hideModalTriggerUpdate())
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Kreirano",
            title: "Kreiranje instrukcije"
        }))
        return response.data;
    }
)


export const updateInstructionItem = createAsyncThunk(
    'instruction/put',
    async ({installationId, triggerItemId, idForUpdate, page = 0, pageSize = 10, data}, {dispatch}) => {
        const response = await api.put(`/api/installations/${installationId}/triggers/${triggerItemId}/instructions/${idForUpdate}`, data)
        dispatch(fetchInstructions({
            installationId: installationId,
            triggerItemId: triggerItemId,
            page: page,
            pageSize: pageSize
        }))
        dispatch(hideModalTriggerUpdate())
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Instrukcija uspješno ažurirana.",
            title: "Ažuriranje instrukcije"
        }))
        return response.data;
    }
)

export const deleteInstruction = createAsyncThunk(
    '/instruction/delete',
    async ({installationId, triggerItemId, idForDelete, page = 0, pageSize = 10}, {dispatch}) => {
        const response = await deleteInstructionUrl(installationId, triggerItemId, idForDelete);
        dispatch(fetchInstructions({
            installationId: installationId,
            triggerItemId: triggerItemId,
            page: page,
            pageSize: pageSize
        }))
        dispatch(displayNotification({notificationStatus: "error", message: "Obrisano", title: "Brisanje instrukcije"}))
        return response.data;
    }
)


const triggersDataSlice = createSlice({
    name: "triggers",
    initialState,
    reducers: {
        openModalTrigger: (state, action) => {
            state.modalVisible = true;
            state.showMessage = false
            state.modalVisibleInstruction = false
        },
        hideModalTrigger: (state, action) => {
            state.modalVisible = false
            state.showMessage = true
            state.isUpdateTrigger = false;
            state.modalVisibleTrigger = false
            state.editTrigger = {}
        },
        openDeleteModalTriggers: (state, action) => {
            state.deleteConfirmationTriggers = true;
            state.idModal = action.payload
        },
        closeDeleteModalTriggers: (state) => {
            state.deleteConfirmationTriggers = false;
        },
        openModalTriggerUpdate: (state, action) => {
            state.modalVisibleInstruction = true;
            state.modalVisible = false
            state.showMessage = false
            state.idModal = action.payload
        },
        hideModalTriggerUpdate: (state, action) => {
            state.modalVisibleInstruction = false
            state.showMessage = true
            state.isUpdateInstruction = false
            state.modalVisibleTrigger = false
            state.editInstruction = {}
        },
        updateItemInstruction: (state, action) => {
            state.editInstruction = action.payload
            state.isUpdateInstruction = true
        },
        updateItemTrigger:(state,action) => {
            state.editTrigger = action.payload
            state.isUpdateTrigger = true
            state.modalVisibleTrigger = true
            state.modalVisible = true
        },
        openDeleteModalInst: (state, action) => {
            state.deleteConfirmation = true;
            state.idModal = action.payload
        },
        closeDeleteModalInst: (state) => {
            state.deleteConfirmation = false;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchTriggersByInstallationsId.pending, state => {
                state.isLoading = true;
                state.appLoader = true;
            })
            .addCase(fetchTriggersByInstallationsId.rejected, state => {
                state.isLoading = false;
                state.triggersItem = [];
                state.appLoader = false;
            })
            .addCase(fetchTriggersByInstallationsId.fulfilled, (state, action) => {
                const {content, totalElements, size, number} = action.payload;
                state.isLoading = false;
                state.appLoader = false;
                state.triggersItem = content
                state.pagination.total = totalElements;
                state.pagination.pageSize = size;
                state.pagination.currentPage = number;
            })
            .addCase(fetchDevicesByInstallationsID.pending, state => {
                state.isLoading = true;
            })
            .addCase(fetchDevicesByInstallationsID.rejected, state => {
                state.isLoading = false;
                state.devicesItemById = [];
            })
            .addCase(fetchDevicesByInstallationsID.fulfilled, (state, action) => {
                state.isLoading = false;
                state.devicesItemById = action.payload
            })
            .addCase(fetchLocationsByInstallationsID.pending, state => {
                state.isLoading = true;
            })
            .addCase(fetchLocationsByInstallationsID.rejected, state => {
                state.isLoading = false;
                state.locationItemById = [];
            })
            .addCase(fetchLocationsByInstallationsID.fulfilled, (state, action) => {
                const {content} = action.payload;
                state.isLoading = false;
                state.locationItemById = content
            })
            .addCase(fetchAllLocations.pending, state => {
                state.isLoading = true;
            })
            .addCase(fetchAllLocations.rejected, state => {
                state.isLoading = false;
                state.allLocationItem = [];
            })
            .addCase(fetchAllLocations.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allLocationItem = action.payload;
            })
            .addCase(createNewTrigger.pending, state => {
                state.creatingTrigger = true
                state.modalVisible = false
                state.isUpdateTrigger = false
                state.modalVisibleTrigger = false
            })
            .addCase(createNewTrigger.rejected, state => {
                state.creatingTrigger = false
                state.modalVisible = false
                state.isUpdateTrigger = false
                state.modalVisibleTrigger = false
            })
            .addCase(createNewTrigger.fulfilled, (state, action) => {
                state.creatingTrigger = true
                state.modalVisible = false
                state.isUpdateTrigger = false
                state.modalVisibleTrigger = false
            })
            .addCase(updateTrigger.pending, (state, action) => {
                state.modalVisible = true
                state.isUpdateTrigger = true
                state.modalVisibleTrigger = true
            })
            .addCase(updateTrigger.rejected, state => {
                state.modalVisible = false
                state.isUpdateTrigger = false
                state.modalVisibleTrigger = false
            })
            .addCase(updateTrigger.fulfilled, (state) => {
                state.modalVisible = false
                state.isUpdateTrigger = false
                state.editTrigger = {}
                state.modalVisibleTrigger = false
            })
            .addCase(deleteTrigger.pending, state => {
                state.deleteConfirmationTriggers = true
            })
            .addCase(deleteTrigger.rejected, state => {
                state.deleteConfirmationTriggers = false
            })
            .addCase(deleteTrigger.fulfilled, (state, action) => {
                state.deleteConfirmationTriggers = false
            })
            .addCase(fetchInstructions.pending, state => {
                state.isLoading = true;
                state.instructionsData = [];
            })
            .addCase(fetchInstructions.rejected, state => {
                state.isLoading = false;
                state.triggersItem = [];
            })
            .addCase(fetchInstructions.fulfilled, (state, action) => {
                const {content, totalElements, size, number} = action.payload;
                state.isLoading = false;
                state.instructionsData = content
                state.paginationInstructions.totalInst = totalElements;
                state.paginationInstructions.pageSizeInst = size;
                state.paginationInstructions.currentPageInst = number;
            })
            .addCase(deleteInstruction.pending, state => {
                state.deleteConfirmation = true
            })
            .addCase(deleteInstruction.rejected, state => {
                state.deleteConfirmation = false
            })
            .addCase(deleteInstruction.fulfilled, (state, action) => {
                state.deleteConfirmation = false
            })
            .addCase(createNewInstruction.pending, state => {
                state.creatingInstallations = true
                state.modalVisible = false
                state.isUpdateInstruction = false
            })
            .addCase(createNewInstruction.rejected, state => {
                state.creatingInstallations = false
                state.modalVisible = false
                state.isUpdateInstruction = false
            })
            .addCase(createNewInstruction.fulfilled, (state, action) => {
                state.creatingInstallations = true
                state.modalVisible = false
                state.isUpdateInstruction = false
            })
            .addCase(updateInstructionItem.pending, (state, action) => {
                state.modalVisible = true
                state.isUpdateInstruction = true
            })
            .addCase(updateInstructionItem.rejected, state => {
                state.modalVisible = false
                state.isUpdateInstruction = false
            })
            .addCase(updateInstructionItem.fulfilled, (state) => {
                state.modalVisible = false
                state.isUpdateInstruction = false
                state.editInstruction = {}
            })
    }
})

export const {
    openModalTrigger,
    hideModalTrigger,
    openDeleteModalTriggers,
    closeDeleteModalTriggers,
    updateItemInstruction,
    openModalTriggerUpdate,
    hideModalTriggerUpdate,
    openDeleteModalInst,
    closeDeleteModalInst,
    updateItemTrigger
} = triggersDataSlice.actions
export default triggersDataSlice.reducer;

